import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { NOTIFICATION_INCORRECT_FIELD_VALUE } from '../../../../../../constants/notification'
import { getFormNotificationIncorrectFieldValue } from '../../../../../../utils/notification'
import { useFormValidationErrorsNotification } from '../../../../../Form'
import { EMAIL_CREATION_FORM_TO_FIELD_ERROR_INCORRECT_VALUE } from '../../../EmailCreationForm.constants'

export function useEmailFormFieldsValidation({
  filesError,
  filesUploading,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  useFormValidationErrorsNotification({
    files: { filesError, filesUploading },
    onRemoveNotification,
    onSetNotification,
  })

  useEffect(() => {
    if (errors[EMAIL_CREATION_FORM_TO_FIELD_ERROR_INCORRECT_VALUE]) {
      onSetNotification(getFormNotificationIncorrectFieldValue(t))
    } else {
      onRemoveNotification(NOTIFICATION_INCORRECT_FIELD_VALUE)
    }
  }, [errors])
}
